import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { retrieveSlider } from "../../redux/slice/slider-slice";
import { useAppDispatch, RootState } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";
import PastConvergenceAgendas from "../../assets/images/Past-Convergence-Agendas-1600x400.png";
import { retrieveSliderPhiladelphia } from "../../redux/slice/slider-philadelphia-slice";
import { useDynamicScripts } from "../../hooks/useDynamicScript";

const Convergence2023About = () => {
  const path = "Convergence-2023%2FAbout";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const { SliderData } = useSelector((state: RootState) => state.Slider);
  const { SliderPhiladelphiaData } = useSelector((state: RootState) => state.SliderPhiladelphia);

  const [width, setWidth] = useState(window.innerWidth);

  const xxlarge = width >= 1201;
  const xlarge = width >= 1025 && width <= 1200;
  const large = width >= 601 && width <= 1024;
  const medium = width >= 401 && width <= 600;

  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: xxlarge ? 5 : xlarge ? 4 : large ? 3 : medium ? 2 : 1,
    slidesToScroll: xxlarge ? 5 : xlarge ? 4 : large ? 3 : medium ? 2 : 1,
    centerMode: true,
    variableWidth: false,
    focusOnSelect: true,
  };

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveSlider(`%2FConvergence-2023%2FAbout%2FPhoenix-Slider`));
    dispatch(retrieveSliderPhiladelphia(`%2FConvergence-2023%2FAbout%2FPhiladelphia-Slider`));
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }

  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-about-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023AboutStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div className="container">
        <p>&nbsp;</p>
        <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      </div>
      <p>&nbsp;</p>
      <div className="container " style={{ padding: "0 0px" }}>
        <div style={{ textAlign: "center", minHeight: "650px", backgroundImage: `url(${PastConvergenceAgendas})` }}>
          <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.extraDescriptionFieldOne }}></div>
          <div className="hero convergence pink-arrow">
            <div className="gallery cursor-grab">
              <Slider {...settings}>
                {SliderData[0]?.sliderItemsList?.map((item, index) => {
                  return <div key={index} dangerouslySetInnerHTML={{ __html: item.sliderContents }}></div>;
                })}
              </Slider>
            </div>

            <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.extraDescriptionFieldTwo }}></div>
            <div className="gallery cursor-grab">
              <Slider {...settings}>
                {SliderPhiladelphiaData[0]?.sliderItemsList?.map((item, index) => {
                  return <div key={index} dangerouslySetInnerHTML={{ __html: item.sliderContents }}></div>;
                })}
              </Slider>
            </div>
          </div>

          <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.extraDescriptionFieldThree }}></div>
        </div>
      </div>
    </>
  );
};

export default Convergence2023About;

const Convergence2023AboutStyleComponent = () => {
  return (
    <>
      <style>
        {`
        .benefits {
          text-align: center;
         }
         .benefits .description {
           font-size: 17px;
           color: #19204A;
           font-style: italic;
           margin-top: 20px;
         }
         
         .gallery { margin-bottom: 40px; }
         .gallery-cell { margin-right: 10px; }
         .gallery-cell img { width: 266px; }
         .flickity-button { 
           background: hsla(338, 59.1%,36.5%,.75) !important;
         }
         .flickity-button-icon { 
           fill: hsla(40, 100%, 50%, .6) !important; 
         }
         .flickity-page-dots { display: none; }
         @media (max-width: 767px) {
         }
         .convergence .slick-slide{
            padding-left: 5px;
            padding-right: 5px;
         }
         .gallery-cell{
          margin-right: 0;
         }
         .hero.convergence{
          padding-bottom: 0;
         }
         .slick-track{
          left: calc(50% - 40vw);
         }
         @media(min-width: 401px){
          .slick-track{
            left: calc(50% - 75vw)
           }
         }
         @media(min-width: 601px){
          .slick-track{
            left: calc(50% - 75vw)
           }
         }
         @media(min-width: 768px){
          .slick-track{
            left: calc(50% - 65vw)
           }
         }
         @media(min-width: 1024px){
          .slick-track{
            left: calc(50% - 68vw)
           }
         }
         @media(min-width: 1200px){
          .slick-track{
            left: -420px
           }
         }
      `}
      </style>
    </>
  );
};
